
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["asyncChances"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "c247fb8e13969ddae1ea.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "c247fb8e13969ddae1ea.worker.js");
					addMethods(w, methods)
					
					return w
				}
			